import { Typography, Input } from "antd";

export interface MfaOtpInputProps {
  promptText: string;
  error?: string | null;
  isPending: boolean;
  onComplete: (code: string) => void;
}

// 6-digit code entry, shared by SmsFactorCard and TotpFactorCard — the
// enrollment flows around it differ, but this final verify step is identical.
export const MfaOtpInput = ({
  promptText,
  error,
  isPending,
  onComplete,
}: MfaOtpInputProps) => (
  <>
    <Typography.Text>{promptText}</Typography.Text>
    <Input.OTP
      length={6}
      status={error ? "error" : undefined}
      disabled={isPending}
      onChange={(value) => {
        if (value.length === 6) onComplete(value);
      }}
    />
    {error && <Typography.Text type="danger">{error}</Typography.Text>}
  </>
);
